import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'app/core/authentication';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { MergeAccountDataService } from 'app/shared/services/merge-account-data-service';
import { MergeInfoModel } from 'app/shared/models/merge-info.model';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TEACHERS_ROUTE } from 'app/teachers/teachers-routing.constant';
import { TOKEN_STORAGE_KEYS } from 'app/core/authentication/constants/token-storage-keys';

@Component({
    selector: 'kh-merge-account-confirmation',
    styleUrls: ['./merge-account-confirmation.component.less'],
    templateUrl: './merge-account-confirmation.component.html',
    standalone: false
})
export class MergeAccountConfirmationComponent implements OnInit {
  public mergeInfo$: Observable<MergeInfoModel> | undefined = undefined;
  public confirmMergeForm!: FormGroup;
  public destination = '';
  public confirmMergeFormFields = {
    agree: 'agree'
  }

  public constructor(
    private formBuilder: FormBuilder,
    private readonly activatedRoute: ActivatedRoute,
    private readonly location: Location,
    private readonly mergeAccountDataService: MergeAccountDataService,
    private readonly authenticationService: AuthenticationService
  ) { }

  public ngOnInit(): void {

    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    this.destination = queryParams.get('destination') as string;
    this.mergeInfo$ = this.mergeAccountDataService.getMergeInfo(this.destination);
    this.confirmMergeForm = this.getConfirmMergeForm();

  }

  public backButton(): void {
    this.location.back();
  }

  public getConfirmMergeForm(): FormGroup {
    return this.formBuilder.group({
      [this.confirmMergeFormFields.agree]: this.formBuilder.control(false, Validators.requiredTrue)
    });
  }

  public getCheckboxControl(): FormControl {

    return this.confirmMergeForm.get(this.confirmMergeFormFields.agree) as FormControl;
  }

  public merge(): void {

    this.mergeAccountDataService.mergeAccount(this.destination)
      .pipe(
        tap(() => {
          const postLogoutRedirect = {
            params: {},
            url: TEACHERS_ROUTE.MERGE_COMPLETE.route()
          };
          localStorage.setItem(TOKEN_STORAGE_KEYS.POST_LOGOUT_REDIRECT, JSON.stringify(postLogoutRedirect));
          this.authenticationService.logOut();
        }))
      .subscribe();
  }
}
